import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import BeachWebp from './images/a-man-on-the-beach-staring-at-the-ocean.webp';
import CoupleWebp from './images/a-couple-looking-at-tablet-with-advisor.webp';
import KitchenWebp from './images/mother-and-daughter-in-the-kitchen.webp';
import PoolWebp from './images/father-and-daughter-swimming-in-a-pool.webp';
// styles
import {
  ColStyledLeft,
  ColStyledRight,
  PictureStyled,
  RowStyled,
} from './styles';

export default () => {
  return (
    <SectionContainer id='private-wealth-management-our-approach'>
      <Row align='center'>
        <Col>
          <Typography
            component='h2'
            accent='pcgHeading'
            branding='pcg'
            align='center'
            nextElement='typography'>
            Our exclusive private wealth <WidowBlock>management approach</WidowBlock>
          </Typography>
        </Col>
      </Row>
      {/* ROW 1  /////////////////////////////////////////////////////////// */}
      <RowStyled
        align='center'
        hasBorder>
        <ColStyledLeft medium={6}>
          <PictureStyled
            src={BeachWebp}
            altText='A man on the beach staring out at the ocean'
          />
        </ColStyledLeft>
        <ColStyledRight medium={6}>
          <Typography
            component='h3'
            branding='pcg'
            nextElement='typography'>
            A broader perspective for better <WidowBlock>wealth planning</WidowBlock>
          </Typography>
          <Typography disableBottomPadding>
            Every great financial plan should begin with the plans you have for your life. So we start by understanding your vision, values, and evolving goals before recommending anything. We then design a comprehensive plan that combines advanced investment and risk management strategies, allowing you to plan even more confidently for your future.
          </Typography>
        </ColStyledRight>
      </RowStyled>
      {/* ROW 2  /////////////////////////////////////////////////////////// */}
      <RowStyled
        align='center'
        reverse
        hasBorder>
        <ColStyledLeft medium={6}>
          <Typography
            component='h3'
            branding='pcg'
            nextElement='typography'>
            Expert guidance for more <WidowBlock>complex portfolios</WidowBlock>
          </Typography>
          <Typography disableBottomPadding>
            Our Private Client Services investment advisory solution gives you access to exclusive wealth management and specialized portfolios that help build, protect and manage wealth. You and your Northwestern Mutual advisor will work with a seasoned team that specializes in handling the unique needs that come with more wealth, including consolidating existing investment accounts, distributing wealth to your loved ones, and maximizing the tax efficiency of your portfolio.
          </Typography>
        </ColStyledLeft>
        <ColStyledRight medium={6}>
          <PictureStyled
            src={CoupleWebp}
            altText='A happy couple looking at a tablet with an advisor'
          />
        </ColStyledRight>
      </RowStyled>
      {/* ROW 3  /////////////////////////////////////////////////////////// */}
      <RowStyled
        align='center'
        hasBorder>
        <ColStyledLeft medium={6}>
          <PictureStyled
            src={PoolWebp}
            altText='A happy couple swimming in a pool together'
          />
        </ColStyledLeft>
        <ColStyledRight medium={6}>
          <Typography
            component='h3'
            branding='pcg'
            nextElement='typography'>
            Maximized wealth planning strategies to minimize <WidowBlock>tax impact</WidowBlock>
          </Typography>
          <Typography disableBottomPadding>
            Working with our Private Client Group gives you exclusive access to Northwestern Mutual products, solutions, and planning experts to help maximize your tax benefits. Our disciplined approach sheds light on how informed tax decisions can reduce the impact to you and your legacy.
          </Typography>
        </ColStyledRight>
      </RowStyled>
      {/* ROW 4  /////////////////////////////////////////////////////////// */}
      <RowStyled
        align='center'
        reverse>
        <ColStyledLeft medium={6}>
          <Typography
            component='h3'
            branding='pcg'
            nextElement='typography'>
            A commitment to building <WidowBlock>generational wealth</WidowBlock>
          </Typography>
          <Typography disableBottomPadding>
            Building an enduring legacy comes from working with an enduring firm. Our Private Client Group firms build teams to plan with all generations of your family, even before they have wealth of their own. Through our multigenerational planning, we&#39;ll help you protect and preserve what you&#39;ve worked so hard for.
          </Typography>
        </ColStyledLeft>
        <ColStyledRight medium={6}>
          <PictureStyled
            src={KitchenWebp}
            altText='A grandmother and granddaughter making a salad together in a kitchen'
          />
        </ColStyledRight>
      </RowStyled>
    </SectionContainer>
  );
};
